function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import queryString from 'query-string-for-all';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { CACHE_KEYS } from '.';
import { api } from './swaggerApi';
var PREFIX_URL = '/insights_platform/projects';
export var list = function() {
    var _ref = _async_to_generator(function(query) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.get(queryString.stringifyUrl({
                            url: PREFIX_URL,
                            query: query
                        }, {
                            arrayFormat: 'bracket'
                        }))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function list(query) {
        return _ref.apply(this, arguments);
    };
}();
export var update = function() {
    var _ref = _async_to_generator(function(identifier, payload) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.put("".concat(PREFIX_URL, "/").concat(identifier), _object_spread_props(_object_spread({}, payload), {
                            identifier: identifier
                        }))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function update(identifier, payload) {
        return _ref.apply(this, arguments);
    };
}();
export var clone = function() {
    var _ref = _async_to_generator(function(identifier, name) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.post("".concat(PREFIX_URL, "/").concat(identifier, "/clone"), {
                            name: name
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function clone(identifier, name) {
        return _ref.apply(this, arguments);
    };
}();
var validations = function() {
    var _ref = _async_to_generator(function(projectIdentifier) {
        var url;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat(PREFIX_URL, "/").concat(projectIdentifier, "/validations");
                    return [
                        4,
                        axios.get(url)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function validations(projectIdentifier) {
        return _ref.apply(this, arguments);
    };
}();
export var updateStatus = function(param) {
    var identifier = param.identifier, status = param.status;
    return axios.post("".concat(PREFIX_URL, "/").concat(identifier, "/update_status"), {
        status: status
    });
};
export var create = function() {
    var _ref = _async_to_generator(function(name, project_type, is_managed, campaignAttributes) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.post("".concat(PREFIX_URL), {
                            name: name,
                            project_type: project_type,
                            is_managed: is_managed,
                            campaigns_attributes: campaignAttributes
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function create(name, project_type, is_managed, campaignAttributes) {
        return _ref.apply(this, arguments);
    };
}();
export var useGetProjects = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var searchQuery = args[0];
    return useQuery([
        CACHE_KEYS.PROJECTS,
        searchQuery
    ], function() {
        return list(searchQuery);
    }, {
        keepPreviousData: true
    });
};
export var useGetProject = function(identifier) {
    var queryClient = useQueryClient();
    return useQuery([
        CACHE_KEYS.PROJECT,
        identifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.projectsDetail({
                            identifier: identifier
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }), {
        // if the project is present in the projects cache, returns it inmediately
        // while performing the query in background to retrieve all the missing data
        placeholderData: function() {
            var projectsCache = queryClient.getQueriesData(CACHE_KEYS.PROJECTS).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), cache = _param[1];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return _to_consumable_array(acc).concat(_to_consumable_array(cache.data.projects));
            }, []);
            var project = projectsCache === null || projectsCache === void 0 ? void 0 : projectsCache.find(function(project) {
                return project.id === identifier;
            });
            return {
                data: _object_spread({}, project)
            };
        }
    });
};
export var useUpdateProjectStatus = function(identifier) {
    var queryClient = useQueryClient();
    var mutation = useMutation(function(status) {
        return updateStatus({
            identifier: identifier,
            status: status
        });
    }, {
        onSuccess: function(data, status) {
            queryClient.setQueriesData(CACHE_KEYS.PROJECTS, function(cache) {
                var updatedProjects = cache.data.projects.map(function(project) {
                    if (project.id === identifier) {
                        project.attributes.status = status;
                        return project;
                    }
                    return project;
                });
                return {
                    data: {
                        projects: updatedProjects
                    }
                };
            });
        }
    });
    return mutation;
};
export var useUpdateProject = function(identifier) {
    var queryClient = useQueryClient();
    var mutation = useMutation(function(newData) {
        return update(identifier, newData);
    }, {
        onSuccess: function(response) {
            queryClient.setQueriesData([
                CACHE_KEYS.PROJECT,
                identifier
            ], function() {
                return response;
            });
            queryClient.setQueriesData(CACHE_KEYS.PROJECTS, function(cache) {
                var updatedProjects = cache.data.projects.map(function(project) {
                    if (project.id === identifier) {
                        var data = response.data;
                        return _object_spread({}, data);
                    }
                    return project;
                });
                return {
                    data: {
                        projects: updatedProjects
                    }
                };
            });
        }
    });
    return mutation;
};
export var useCreateProject = function() {
    var queryClient = useQueryClient();
    return useMutation(function(args) {
        return create.apply(void 0, _to_consumable_array(args));
    }, {
        onSuccess: function(data) {
            queryClient.setQueryData([
                CACHE_KEYS.PROJECT,
                data.data.id
            ], data);
            queryClient.invalidateQueries([
                CACHE_KEYS.PROJECTS
            ]);
        }
    });
};
export var useCloneProject = function() {
    var queryClient = useQueryClient();
    return useMutation(function(args) {
        return clone.apply(void 0, _to_consumable_array(args));
    }, {
        onSuccess: function(data) {
            queryClient.setQueryData([
                CACHE_KEYS.PROJECT,
                data.data.id
            ], data);
            queryClient.invalidateQueries([
                CACHE_KEYS.PROJECTS
            ]);
        }
    });
};
export var useProjectValidation = function(projectIdentifier) {
    return useQuery([
        CACHE_KEYS.PROJECT_VALIDATION,
        projectIdentifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data, isProjectValid, isCampaignValid, notifications, _data_campaign_errors, campaign_errors, campaign_cost, _campaign_errors_questions_errors, questions_errors, rest, _ref, amountDue, totalCost;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        validations(projectIdentifier)
                    ];
                case 1:
                    data = _state.sent().data;
                    isProjectValid = data.valid_project, isCampaignValid = data.valid_campaign, notifications = data.notifications, _data_campaign_errors = data.campaign_errors, campaign_errors = _data_campaign_errors === void 0 ? {} : _data_campaign_errors, campaign_cost = data.campaign_cost;
                    _campaign_errors_questions_errors = campaign_errors.questions_errors, questions_errors = _campaign_errors_questions_errors === void 0 ? [] : _campaign_errors_questions_errors, rest = _object_without_properties(campaign_errors, [
                        "questions_errors"
                    ]);
                    _ref = campaign_cost || {}, amountDue = _ref.amount_due, totalCost = _ref.total;
                    return [
                        2,
                        {
                            isProjectValid: isProjectValid,
                            isCampaignValid: isCampaignValid,
                            amountDue: amountDue,
                            totalCost: totalCost,
                            notifications: notifications,
                            errors: _object_spread_props(_object_spread({}, rest), {
                                questions: extractErrors(questions_errors)
                            })
                        }
                    ];
            }
        });
    }), {
        enabled: !!projectIdentifier
    });
};
var extractErrors = function(data) {
    return data.reduce(function(acc, item) {
        return _object_spread({}, acc, item);
    }, {}) || {};
};
export var useGetProjectStatusesCount = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useQuery([
        CACHE_KEYS.PROJECT_STATUSES_COUNT,
        args
    ], /*#__PURE__*/ _async_to_generator(function() {
        var urlWithQueryParams;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // TODO: api generation doesn't work for get requests with params, we can fix this by writing our own axios template
                    urlWithQueryParams = queryString.stringifyUrl({
                        url: '/insights_platform/project_status_counts',
                        query: {
                            managed: args[0],
                            project_type: args[1],
                            date: args[2],
                            user_id: args[3]
                        }
                    }, {
                        arrayFormat: 'bracket'
                    });
                    return [
                        4,
                        api.insightsPlatform.projectStatusCountsList({
                            projectType: '',
                            date: '',
                            userId: ''
                        }, {
                            path: urlWithQueryParams
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), {
        keepPreviousData: true
    });
};
